"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCrossReferenceType = void 0;
var ProductCrossReferenceType;
(function (ProductCrossReferenceType) {
    ProductCrossReferenceType["Partner"] = "Partner";
    ProductCrossReferenceType["Manufacturer"] = "ProductManufacturer";
})(ProductCrossReferenceType = exports.ProductCrossReferenceType || (exports.ProductCrossReferenceType = {}));
//# sourceMappingURL=product-cross-reference-type.enum.js.map